import { useCallback, useEffect, useState } from "react";

import { subscriptionManager } from "../utils/subscriptionManager";

export function useSubscriptionPopup() {
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  useEffect(() => {
    const unsubscribe = subscriptionManager.subscribe((isExpired) => {
      setShowSubscriptionPopup(Boolean(isExpired));
    });

    return unsubscribe;
  }, []);

  const handleSelectPlan = useCallback(async () => {
    subscriptionManager.reset();
    setShowSubscriptionPopup(false);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowSubscriptionPopup(false);
  }, []);

  return {
    showSubscriptionPopup,
    handleSelectPlan,
    handleClosePopup,
  };
}
